export default __webpack_public_path__ + "static/media/upload.df3982f5.png";